import { useMutation } from '@tanstack/react-query'
import { blocks } from '../../../v3/blocks'

type DeleteBlockParams = {
  id: string
}

type QueryParams = {
  onMutate?: (params: DeleteBlockParams) => void
  onSuccess?: (data: null, params: DeleteBlockParams) => void
}

export const useDeleteBlock = ({ onMutate, onSuccess }: QueryParams) => {
  return useMutation({
    mutationFn: ({ id }: DeleteBlockParams) => {
      return blocks.delete({
        params: {
          path: { block_id: id },
        },
      })
    },
    onMutate,
    onSuccess,
  })
}
